export default __webpack_public_path__ + "static/media/diagnosticCenter.c8f444c5.svg";